import { render, staticRenderFns } from "./NotAuthPage.vue?vue&type=template&id=953e2460&"
import script from "./NotAuthPage.vue?vue&type=script&lang=js&"
export * from "./NotAuthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports